import classNames from 'classnames';
import PropTypes from 'prop-types';
import Hero from '../Hero';
import HeroButton from '../HeroButton';
import LogoSection from '@components/PageComponents/LogoSection/LogoSection';

import Styles from './Styles.module.scss';

const Size = {
  SMALL: Styles.small,
  MEDIUM: Styles.medium,
  LARGE: Styles.large,
};

const NewEnterpriseHero = ({
  title,
  description,
  contentClassName,
  containerClassName,
  showCustomers = true,
  showCtaButton = true,
  size = Size.LARGE,
}) => {
  return (
    <Hero
      parent={Hero.Page.NEW_ENTERPRISE}
      containerClass={classNames(size, containerClassName, Styles.container)}>
      <div className={classNames(Hero.Styles.heroContainer, Styles.hero, contentClassName)}>
        <h1 className={Hero.Styles.heroTitle}>{title}</h1>
        <p className={Hero.Styles.heroDescription}>{description}</p>
        {showCtaButton && (
          <div className={Styles.heroCta}>
            <HeroButton type={HeroButton.Type.WHITE} title='' to='/schedule-call'>
              {`Work With Talent`}
            </HeroButton>
          </div>
        )}
        {showCustomers && (
          <div className={Styles.heroBottom}>
            <LogoSection removeBackground opacity={70} />
          </div>
        )}
      </div>
    </Hero>
  );
};

NewEnterpriseHero.Size = Size;

NewEnterpriseHero.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  customerNames: PropTypes.array,
};

export default NewEnterpriseHero;
